module.exports = __webpack_public_path__ + "img/yiYuanPeiHu.f65dcbea.png";